import { SlotBand } from './captureSlotGeometry';

/**
 * Resolves a pointer's frozen-space Y coordinate to the band under it — or, when
 * the pointer sits above the first band, below the last, or in a border gap, the
 * nearest band by vertical distance. Pure vertical hit-testing: the drag is
 * restricted to the vertical axis and every row spans the table, so the Y band
 * alone identifies the slot the user means.
 */
export function resolveSlot(bands: SlotBand[], frozenY: number): SlotBand | null {
  let winner: SlotBand | null = null;
  let winnerDistance = Infinity;

  for (const band of bands) {
    const distance = frozenY < band.top
      ? band.top - frozenY
      : frozenY > band.bottom ? frozenY - band.bottom : 0;

    if (distance < winnerDistance) {
      winnerDistance = distance;
      winner = band;
    }
  }

  return winner;
}
